var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},_vm._l((_vm.sessions),function(s){
var _obj;
return _c('program-session',{key:s.id,class:[_vm.$style.session, ( _obj = {}, _obj[_vm.$style.sessionNotActive] = !_vm.isSessionInActiveHall(s), _obj )],style:({
      '--width': _vm.getSessionWidth(s),
      height: _vm.getSessionHeight(s),
      left: _vm.getSessionLeft(s),
      top: _vm.getSessionTop(s),
    }),attrs:{"session":s,"active-group":_vm.getActiveGroup(s.track.group.alias)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }